import {Component, HostListener, ViewChild, ViewEncapsulation} from '@angular/core';
import {BaseCellEditorComponent} from '../base-cell-editor/base-cell-editor.component';
import {NgbDate, NgbInputDatepicker} from '@ng-bootstrap/ng-bootstrap';
import {ITableVerticalDataRow} from '../../table-vertical-api-adapter';
import {dateObjectToISOString, EsvgFiles} from 'frontier/nucleus';
import {
  DateElementComponent
} from '../../../form-control/dynamic-form/form-element/date-element/date-element.component';

@Component({
  selector: 'kpi4me-date-cell-editor',
  templateUrl: './date-cell-editor.component.html',
  styleUrls: ['./date-cell-editor.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [DateElementComponent],
})
export class DateCellEditorComponent extends BaseCellEditorComponent {
  @ViewChild(NgbInputDatepicker) datePickerRef: NgbInputDatepicker;
  dateString: NgbDate;

  override set row(r: ITableVerticalDataRow) {
    super.row = r;
    this.internalSetData(r);
  }

  private internalSetData(r: ITableVerticalDataRow) {
    if (r.value) {
      this.formControl.setValue(r.value);
      this.initialValue = this.getValueForApi();
    }
  }

  override get row() {
    return super.row;
  }

  @HostListener('keydown.enter', ['$event'])
  override onEnter(event: KeyboardEvent) {
    if (this.formControl.status !== 'VALID') {
      return;
    }
    this.changeValue().subscribe(() => {
      const cellEditorWrapper = this.renderer.parentNode(this.element.nativeElement);
      const td = this.renderer.parentNode(cellEditorWrapper);
      const tr = this.renderer.parentNode(td);
      const nextRow = this.renderer.nextSibling(tr);
      console.log(nextRow);
      try {
        const inputOfNextRow = nextRow.children[1].children[0].children[0].children[0];
        (<HTMLInputElement>inputOfNextRow).focus();
      } catch (e) {
        console.warn('Could not select next input element');
      }
    })

  }

  override updateRow(r: ITableVerticalDataRow) {
    super.updateRow(r);
    this.internalSetData(r);
  }


  override getValueForApi = () => {
    this.cdr.detectChanges();
    if (this.formControl.value) {
      return dateObjectToISOString(this.formControl.value);
    }
    return null;
  }

  override confirmChange() {
    if (this.formControl.status === 'VALID') {
      super.confirmChange();
    }
  }

  protected readonly EsvgFiles = EsvgFiles;
}
